import { MapLayerType } from '@kinetic-ui/data-layer';
import useMapLayerAttributionsStyles from './styles';
import { GoogleMapType, KineticMapContext } from 'components/maps';
import { useContext } from 'react';
import { GOOGLE_ROADMAP_DEFAULT_ATTRIBUTION, GOOGLE_SATELLITE_DEFAULT_ATTRIBUTION } from './const';

export const MapLayerAttributions = () => {
  const classes = useMapLayerAttributionsStyles();
  const { selectedBaseLayerConfig } = useContext(KineticMapContext);
  let attribution = selectedBaseLayerConfig?.data?.attribution;

  if (!attribution) {
    if (selectedBaseLayerConfig?.type !== MapLayerType.Google) {
      return null;
    }
    attribution =
      selectedBaseLayerConfig?.data?.googleMapType === GoogleMapType.SATELLITE
        ? GOOGLE_SATELLITE_DEFAULT_ATTRIBUTION
        : GOOGLE_ROADMAP_DEFAULT_ATTRIBUTION;
  }

  return <div dangerouslySetInnerHTML={{ __html: attribution }} className={classes.attribution} />;
};
